const appInfo = {
    title: 'Reloj Checador'
};
export default appInfo;

